exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".key-value-pair {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-default);\n}\n\n.key-value-pair input {\n  max-width: 40%;\n  margin-right: var(--spacing-default);\n}\n\n.key-value-pair textarea { \n  resize: vertical;\n  margin-right: var(--spacing-default);\n}\n\n.key-value-pair__input--error,\n.key-value-pair__input--error[disabled][disabled],\n.key-value-pair__input--error:focus {\n  border-color: var(--danger-color);\n}", ""]);

// exports
